import React from "react";
import { Box, IconButton, Typography } from "@material-ui/core";
import { ArrowBack, ArrowForward } from "@material-ui/icons";
import { useTranslation } from "react-i18next";

type LanguageSelectorProps = {
  localeIndex: number;
  translations: Array<{ locale: string }>;
  onPreviousLocale?: () => void;
  onNextLocale?: () => void;
};

const LanguageSelector: React.FC<LanguageSelectorProps> = ({
  localeIndex,
  translations,
  onPreviousLocale,
  onNextLocale,
}) => {
  const { t } = useTranslation();
  const maxIndex = translations.length - 1;

  if (translations.length <= 1) return null;

  return (
    <Box display="flex" alignItems="center" mb={2}>
      <Typography>{t("imageGenerator.promptLanguage")} </Typography>
      <IconButton size="small" onClick={onPreviousLocale} disabled={localeIndex === 0} color="primary">
        <ArrowBack />
      </IconButton>
      <Box mx={1} minWidth={60} textAlign="center">
        <Typography variant="body2">{translations[localeIndex]?.locale || "N/A"}</Typography>
      </Box>
      <IconButton size="small" onClick={onNextLocale} disabled={localeIndex === maxIndex} color="primary">
        <ArrowForward />
      </IconButton>
    </Box>
  );
};

export default LanguageSelector;
